import couponsAPI from '../../../../_api/coupons';
import { removeCartCoupon, setCoupon } from '../../../actions/cart';

const asyncCouponValidate = async (values, dispatch) => {
    if (values.coupon){
      try {
        let response = await couponsAPI.validate(values.coupon, values.offerType);
        if (response){
          dispatch(removeCartCoupon());
          dispatch(setCoupon(response))
        }
      } catch (e) {
        dispatch(removeCartCoupon());
        dispatch(setCoupon(null))
        throw { 'coupon': e.message };
      }
    }
}

export default asyncCouponValidate;